import { useState } from "react";
import { Divider } from "@mui/material";

import { ServiceRequest } from "../../../types/service.type";
import { CancelModal } from "../../../components/CancelModal";
import { useServiceStatusFlags } from "../../../hooks/useServiceStatusFlags";

import { ProviderActions } from "./ProviderActions";
import { RequesterActions } from "./RequesterActions";

type ModalConfig = {
  title: string;
  subTitle?: string;
  onConfirm: () => void;
};

const useActionModal = () => {
  const [modalConfig, setModalConfig] = useState<ModalConfig | null>(null);

  const openModal = (config: ModalConfig) => setModalConfig(config);
  const closeModal = () => setModalConfig(null);

  return {
    modalConfig,
    openModal,
    closeModal,
  };
};

const ServiceRequestActions = ({
  serviceRequest,
  isContractPaid,
}: {
  serviceRequest: ServiceRequest;
  isContractPaid: boolean;
}) => {
  const { isProvider } = useServiceStatusFlags(serviceRequest);

  const { modalConfig, openModal, closeModal } = useActionModal();

  const handleOpenModal = (config: ModalConfig) => {
    openModal({
      ...config,
      onConfirm: () => {
        config.onConfirm();
        closeModal();
      },
    });
  };

  // Render actions based on provider/requester role
  const actions = isProvider ? (
    <ProviderActions serviceRequest={serviceRequest} isContractPaid={isContractPaid} onOpenModal={handleOpenModal} />
  ) : (
    <RequesterActions
      serviceRequest={serviceRequest}
      isContractPaid={isContractPaid}
      onOpenModal={handleOpenModal}
      onCloseModal={closeModal}
    />
  );

  if (!actions) return null;

  return (
    <>
      {actions}
      {modalConfig && (
        <CancelModal
          open={!!modalConfig}
          closeModal={closeModal}
          handelCancel={modalConfig.onConfirm}
          title={modalConfig.title}
          subTitle={modalConfig.subTitle}
        />
      )}
    </>
  );
};

export default ServiceRequestActions;
